export enum LandingPageEvents {
  CLICK_SEE_MORE = 'click_see_more',
}

export enum NavbarEvents {
  CLICK_LANGUAGE_PICKER = 'click-language-picker',
  CHOOSE_LANGUAGE = 'choose_language',
  TOGGLE_MENU = 'toggle_menu',
  CLICK_USER_MENU = 'toggle_user_menu',
}

export enum ChooseLanguageFrom {
  NAVBAR = 'navbar',
  USER_MENU = 'user_menu',
  MOBILE_MENU = 'mobile_menu',
  CURRICULUM_CHANGE = 'curriculum_change',
}

export enum UserMenus {
  USER_MENU = 'user-menu',
  LANGUAGE = 'language',
  LOGOUT = 'logout',
}

export enum MenuEvents {
  VIEW_MENU_TOOLTIP = 'view_menu_tooltip',
}
